import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Including Model Information",
description: "Connect your Freon-based web app to the server to open/create models, list available models, and populate the Model Drawer. Uses WebappConfigurator, InMemoryModel, and Flowbite dialogs to mirror the standard Freon web app behavior.",
tags: [ "Freon", "Svelte", "Integration", "server", "InMemoryModel", "WebappConfigurator", "Model Drawer", "Flowbite", "SvelteKit", "undo", "projections", "BoxFactory", "samples-education"] ,
modifiedTime: "2025-11-07T17:20:18.645Z",
publishedTime: "2025-11-07T17:20:18.645Z"
    }
  };
};